import { TextBlock } from "@babylonjs/gui/2D/controls/textBlock";
import { Control } from "@babylonjs/gui/2D/controls/control";

/**
 * Configure a TextBlock for wrapped, self-sizing text.
 *
 * Babylon GUI 9.7: `resizeToFit` measures height INCLUDING lineSpacing
 * (TextBlock._processMeasures), but `_renderLines` ignores lineSpacing
 * when computing the CENTER/BOTTOM textVerticalAlignment offset — wrapped
 * text draws (lines-1)*spacing/2 too low and the last line's descenders
 * are clipped by the control's own content clip (Q-033). TOP lays lines
 * out exactly within the measured height, so wrapped+resizeToFit blocks
 * must always pin textVerticalAlignment to TOP.
 */
export function applyWrappedTextLayout(block: TextBlock, lineSpacingPx = 0): void {
  block.textWrapping = true;
  block.resizeToFit = true;
  if (lineSpacingPx > 0) {
    block.lineSpacing = `${lineSpacingPx}px`;
  }
  block.textVerticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
}
